export default __webpack_public_path__ + "static/media/somethingwrong-1.e229ed2f.png";